$(document).ready(function() {
    console.log("Z-COLLECTION FILE LOADED");

    // ---------- Helper: update size drawer options based on selected color ----------
    function updateSizeOptionsForCard($card) {
        const selected_var = $.trim($card.find(".dm_main_product_value_input:checked").attr("option-value") || "");
        const product_id = $card.data('product-id');

        const inventoryJSONElement = $card.find(".custom_variant_quantity--" + product_id);
        let inventoryJSON;
        try {
            inventoryJSON = $.parseJSON(inventoryJSONElement.text());
        } catch (err) {
            console.error("Bad inventory JSON for product", product_id, err);
            return;
        }

        const bottom_option_arr = $(`.z_product_drawer .dm_products_size[data-product-id="${product_id}"] .dm_products_size_value .dm_products_size_value_option`);

        bottom_option_arr.each(function() {
            const $opt = $(this);
            const sizee = $.trim($opt.find(".dm_products_size_value_name").text());
            const temp_val = selected_var + " / " + sizee;
            const inventory_details = inventoryJSON[temp_val];

            const $status = $opt.find(".dm_products_size_value_status");
            const $notify = $opt.find(".dm_products_size_value_notice");

            // Guard: if this color/size combo doesn't exist, mark unavailable and skip
            if (!inventory_details) {
                $opt.addClass("dm_product_main_sold_out");
                $status.text("Unavailable");
                $notify.text("");
                $opt.removeAttr("data-variant-id");
                return;
            }

            const inventory = parseInt(inventory_details.inventory, 10);
            const available = inventory_details.available;
            const variant_id = inventory_details.variant_id; // requires JSON to include this

            // Store variant id on the option so add-to-cart can read it
            if (variant_id) {
                $opt.attr("data-variant-id", variant_id);
            }

            // Low-stock notice
            if (inventory < 5 && inventory > 0) {
                $notify.text(`Hurry, only ${inventory} left`);
            } else {
                $notify.text("");
            }

            // Availability state
            if (!available && inventory === 0) {
                $status.text("Out of Stock");
                $opt.addClass("dm_product_main_sold_out");
            } else {
                if (available && inventory <= 0) {
                    $status.text($('#custId').val());
                } else {
                    $status.text("Available");
                }
                $opt.removeClass("dm_product_main_sold_out");
            }
        });

        // Also update the inline size options inside the card (deny-policy check via swatch <option>)
        const inline_options_arr = $card.find(".dm_products_size_value_option");
        inline_options_arr.each(function() {
            const $size_path = $(this);
            const sizee = $.trim($size_path.find(".dm_products_size_value_name").text());
            const temp_val = selected_var + " / " + sizee;

            $card.find(".dm_product_variants .dm_swatch option").each(function() {
                if ($(this).text().trim() === temp_val) {
                    if ($(this).attr("data-policy") === 'deny' && parseInt($(this).attr("data-size"), 10) <= 0) {
                        $size_path.find("label").css("pointer-events", "none");
                        $size_path.find(".dm_products_size_value_label_parent").addClass("z_product_ui_option_un");
                        $size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Sold out");
                    } else {
                        $size_path.find("label").css("pointer-events", "all");
                        $size_path.find(".dm_products_size_value_label_parent").removeClass("z_product_ui_option_un");
                        $size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Available");
                    }
                }
            });
        });
    }

    // ---------- Initial setup: sync color radios to product-data on page load ----------
    $(".dm_main_collection_product").each(function() {
        const $card = $(this);
        const productData = $card.attr("product-data");
        const varTitle = $card.find(".dm_swatch option[value='" + productData + "']").attr("var-title");

        if (varTitle) {
            const colorName = varTitle.split(" / ")[0].trim();
            $card.find(".dm_main_product_value_input").each(function() {
                if ($(this).attr("option-value") === colorName) {
                    $(this).prop("checked", true).addClass("dm_color_active");
                } else {
                    $(this).prop("checked", false).removeClass("dm_color_active");
                }
            });
        }
    });

    // ---------- Initial setup: sync main image to checked color swatch ----------
    $(".dm_main_collection_product").each(function() {
        const $card = $(this);
        if ($card.find(".dm_main_product_value .swiper-wrapper div").length !== 0) {
            const src = $card.find(".dm_main_product_value input:checked").next().find("img:first-child").attr("src");
            $card.find(".dm_main_product_image img").attr("src", src);
        }
    });

    // ---------- Color swatch change ----------
    $("body").on("change", "#ProductGridContainer .dm_main_product_value_input", function() {
        const $card = $(this).closest(".dm_main_collection_product");
        updateSizeOptionsForCard($card);
    });

    // ---------- Size button click — single consolidated handler ----------
    $("body").on("click", ".z_main_product_button_size", function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $card = $(this).closest(".dm_main_collection_product");

        // Recalculate availability for current color selection
        updateSizeOptionsForCard($card);

        // Open the size drawer
        const product_id = $card.data('product-id');

        // Open inline drawer (inside grid)
        $card.find(".dm_products_size_overlay").addClass("dm_products_size_overlay_e");
        $card.find(".dm_products_size").addClass("z_open");

        // Open bottom drawer (matched by p_id)
        const m_id = $card.attr("p_id");
        $(".z_product_drawer").find(".z_drawer_collection").each(function() {
            if ($(this).attr("p_id") === m_id) {
                $(this).find(".dm_products_size_overlay").addClass("dm_products_size_overlay_e");
                $(this).find(".dm_products_size").addClass("z_open");
            }
        });
    });

    // ---------- Close drawer (overlay) ----------
    $("body").on("click", "#ProductGridContainer .dm_products_size_overlay", function() {
        $(this).closest(".z_collection_dyn").find(".dm_products_size_overlay").removeClass("dm_products_size_overlay_e");
        $(".dm_products_size").removeClass("z_open");
        $("body").removeClass("dm_products_size_hidden");
    });

    // ---------- Close drawer (close button) ----------
    $("body").on("click", "#ProductGridContainer .dm_products_size_close", function() {
        $(this).closest(".z_collection_dyn").find(".dm_products_size_overlay").removeClass("dm_products_size_overlay_e");
        $(".dm_products_size").removeClass("z_open");
        $("body").removeClass("dm_products_size_hidden");
    });

    // ---------- Color image click (alternate color picker) ----------
    $("body").on("click", ".dm_main_product_value_image", function() {
        const $card = $(this).closest(".dm_main_collection_product");
        const src = $(this).find("img:first-child").attr("src");
        $card.find(".dm_main_product_image img").attr("src", src);

        const quantity = $(this).attr("data-quantity");
        if (parseInt(quantity, 10) === 0) {
            $card.find(".dm_main_product_button_adc").css({
                "pointer-events": "none",
                "opacity": "0.5"
            });
        } else {
            $card.find(".dm_main_product_button_adc").css({
                "pointer-events": "all",
                "opacity": "1"
            });
        }
    });
});